import * as React from "react";
const SvgMagicWand02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.269 11.269a1.034 1.034 0 1 1 1.462 1.462l-9 9A1.034 1.034 0 1 1 2.27 20.27zM13.965 16v-2a1.035 1.035 0 0 1 2.07 0v2a1.035 1.035 0 0 1-2.07 0m3.103-4.932a1.035 1.035 0 0 1 1.464 0l1.2 1.2a1.034 1.034 0 1 1-1.463 1.463l-1.2-1.199a1.035 1.035 0 0 1 0-1.464M10 7.965a1.035 1.035 0 0 1 0 2.07H8a1.035 1.035 0 0 1 0-2.07zm12 0a1.035 1.035 0 0 1 0 2.07h-2a1.035 1.035 0 0 1 0-2.07zM10.269 4.269a1.034 1.034 0 0 1 1.462 0l1.2 1.199a1.035 1.035 0 0 1-1.463 1.464l-1.2-1.2a1.034 1.034 0 0 1 0-1.463m8 0A1.034 1.034 0 1 1 19.73 5.73l-1.199 1.2a1.035 1.035 0 0 1-1.464-1.463zM13.965 4V2a1.035 1.035 0 0 1 2.07 0v2a1.035 1.035 0 0 1-2.07 0"
}));
export default SvgMagicWand02;
//# sourceMappingURL=MagicWand02.js.map